import { createFeatureSelector } from '@ngrx/store';
import { SearchBrandState } from '../models/brand-search.model';
import { BrandManagementReducer } from './brand-management.reducer';

export const featureBrandManagementName = 'BrandManagement';

export interface DragonflyState {
  brandManagement: SearchBrandState;
}

export const moduleBrandManagementReducers = {
  brandManagement: BrandManagementReducer,
};

export const getDragonflyState = createFeatureSelector<DragonflyState>(
  featureBrandManagementName
);
